// import React from "react";
// import { gql, useQuery } from "@apollo/client";
// import { useNavigate } from "react-router-dom";
// import {
//   Container,
//   Paper,
//   Typography,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Box,
//   Grid,
//   Stack,
//   Avatar,
//   useTheme,
//   Divider,
//   Button
// } from "@mui/material";
// import {
//   PeopleAltRounded,
//   BusinessCenterRounded,
//   BadgeRounded,
//   EmojiPeopleRounded
// } from "@mui/icons-material";
// import LoadingPage from "./LoadingPage";
// import OwwLogo from '../Assets/owwtransparentlogo.png';
// import sidebardImage from "../Assets/newImage/header-image.png";
// import BackgroundShape from '../Assets/Background-Shape.png';

// const GET_ROLES = gql`
//     query getRoles($eventId: String!) {
//         getRoles(eventId: $eventId)
//     }
// `;

// const roleIcons = {
//   'Delegate': <PeopleAltRounded />,
//   'Exhibitor': <BusinessCenterRounded />,
//   'Staff': <BadgeRounded />,
//   'Speaker': <EmojiPeopleRounded />,
//   // Add more role-icon mappings as needed
// };

// const SelectRole = () => {
//   const theme = useTheme();
//   const navigate = useNavigate();
//   const eventId = "6220072402";
//   const { data, loading, error } = useQuery(GET_ROLES, {
//     variables: { eventId },
//   });

//   const handleRoleClick = (role) => {
//     navigate(`/login/${eventId}/${role}`);
//   };

//   if (error) {
//     return (
//       <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
//         <Typography color="error">{error.message}</Typography>
//       </Box>
//     );
//   }

//   if (loading) {
//     return <LoadingPage />
//   }

//   return (
//     <Grid container sx={{
//       minHeight: "100vh",
//       background: `linear-gradient(135deg, #2a4b50 0%, #2a4b50 100%)`,
//       color: theme.palette.common.white,
//       p: 4,
//       position: 'relative',
//       overflow: 'hidden',
//       '&::before': {
//         content: '""',
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '100%',
//         height: '100%',
//         backgroundImage: `url(${BackgroundShape})`,
//         backgroundSize: 'cover',
//         opacity: 0.1,
//       }
//     }}>
//       <Grid item md={6} sx={{
//         display: { xs: "none", md: "flex" },
//         alignItems: 'center',
//         justifyContent: 'center',
//         position: 'relative',
//         zIndex: 1
//       }}>
//         <Box sx={{
//           maxWidth: '80%',
//           borderRadius: 4,
//           overflow: 'hidden',
//         //   boxShadow: theme.shadows[10]
//         }}>
//           <img
//             src={sidebardImage}
//             alt="Conference"
//             style={{
//               width: "100%",
//               height: "auto",
//               objectFit: 'cover',
//               transform: 'scale(1.05)'
//             }}
//           />
//         </Box>
//       </Grid>

//       <Grid item md={6} xs={12} sx={{
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'center',
//         alignItems: 'center',
//         position: 'relative',
//         zIndex: 1
//       }}>
//         <Box sx={{
//           maxWidth: 500,
//           width: '100%',
//           textAlign: 'center',
//           mb: 4
//         }}>
//           <img
//             src={OwwLogo}
//             alt="Logo"
//             style={{
//               width: "200px",
//               height: "auto",
//               filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.2))'
//             }}
//           />
//           <Typography variant="h3" sx={{
//             mt: 3,
//             mb: 2,
//             fontWeight: 700,
//             letterSpacing: 1.5,
//             color: theme.palette.common.white
//           }}>
//             Select Your Role
//           </Typography>
//           <Typography variant="body1" sx={{
//             color: 'rgba(255,255,255,0.9)',
//             mb: 4,
//             fontSize: '1.1rem'
//           }}>
//             Choose your participation type to continue
//           </Typography>
//         </Box>

//         <Container maxWidth="sm">
//           <Paper sx={{
//             borderRadius: 4,
//             background: 'rgba(255,255,255,0.1)',
//             backdropFilter: 'blur(10px)',
//             boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
//             border: '1px solid rgba(255,255,255,0.15)',
//             overflow: 'hidden'
//           }}>
//             {data?.getRoles?.length > 0 ? (
//               <List disablePadding>
//                 {data.getRoles.map((role, index) => (
//                   <React.Fragment key={role}>
//                     <ListItem
//                       button
//                       onClick={() => handleRoleClick(role)}
//                       sx={{
//                         py: 2.5,
//                         transition: 'all 0.3s ease',
//                         '&:hover': {
//                           background: 'rgba(255,255,255,0.15)',
//                           transform: 'translateX(8px)'
//                         },
//                         '&:active': {
//                           transform: 'scale(0.98)'
//                         }
//                       }}
//                     >
//                       <ListItemIcon sx={{ minWidth: 48 }}>
//                         <Avatar sx={{
//                           bgcolor: 'rgba(255,255,255,0.2)',
//                           color: theme.palette.common.white
//                         }}>
//                           {roleIcons[role] || <PeopleAltRounded />}
//                         </Avatar>
//                       </ListItemIcon>
//                       <ListItemText
//                         primary={role}
//                         primaryTypographyProps={{
//                           variant: 'h6',
//                           fontWeight: 600,
//                           color: theme.palette.common.white,
//                           textTransform: 'capitalize'
//                         }}
//                       />
//                     </ListItem>
//                     {index < data.getRoles.length - 1 && (
//                       <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)' }} />
//                     )}
//                   </React.Fragment>
//                 ))}
//               </List>
//             ) : (
//               <Box sx={{
//                 p: 4,
//                 textAlign: 'center',
//                 color: 'rgba(255,255,255,0.8)'
//               }}>
//                 <Typography variant="h6">
//                   No roles available at the moment
//                 </Typography>
//                 <Typography variant="body2" sx={{ mt: 1 }}>
//                   Please check back later or contact support
//                 </Typography>
//               </Box>
//             )}
//           </Paper>
//         </Container>
//       </Grid>
//     </Grid>
//   );
// };

// export default SelectRole;

import React, { useState, useEffect } from "react";
import { LoadingButton } from "@mui/lab";
import {
  Container,
  Grid,
  LinearProgress,
  Paper,
  Stack,
  TextField,
  Typography,
  useTheme,
  Link,
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  InputAdornment,
  Fade,
  Zoom,
  styled,
  Box,
  Slide,
  Divider,
  IconButton,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { gql, useMutation } from "@apollo/client";
import { motion, AnimatePresence, LayoutGroup } from "framer-motion";
import {
  EmailRounded,
  LockRounded,
  ArrowForwardRounded,
  CloseRounded,
} from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import OwwLogo from "../Assets/owwtransparentlogo.png";
import sidebardImage from "../Assets/newImage/header-image.png";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import LanguageSwitcher from "../components/LanguageSwitcher";

const GlassPaper = styled(Paper)(({ theme }) => ({
  background: `linear-gradient(145deg, #2a4b50 0%, #2a4b50 100%)`,
  backdropFilter: "blur(10px)",
  boxShadow: `${theme.shadows[10]}, inset 0 1px 1px rgba(255,255,255,0.1)`,
  border: "1px solid rgba(255,255,255,0.15)",
  position: "relative",
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(255,255,255,0.05)",
    zIndex: 0,
  },
}));

export default function LoginPage() {
  const theme = useTheme();
  const { t } = useTranslation();
  const [isSignup, setIsSignup] = useState(false);
  const [login, { loading, error }] = useMutation(gql`
    mutation ($eventId: String!, $email: String!, $password: String!) {
      token: loginv2withEmail(
        eventId: $eventId
        email: $email
        password: $password
      )
    }
  `);
  const navigate = useNavigate();
  const eventId = "6220072402";

  const onLogin = async (variables) => {
    try {
      const response = await login({ variables: { ...variables, eventId } });
      if (response.data?.token) {
        localStorage.setItem("auth.app.eventegration.com", response.data.token);
        navigate("/demo");
      }
    } catch (err) {
      console.error("Login error:", err);
    }
  };

  const handleRoleClick = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div>
      <LanguageSwitcher position="fixed" />

      <Grid
        container
        sx={{
          minHeight: "100vh",
          background: `linear-gradient(135deg, #2a4b50 30%, #2a4b50 90%)`,
          position: "relative",
          overflow: "hidden",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: `url(${sidebardImage})`,
            backgroundSize: "cover",
            opacity: 0.05,
          },
        }}
      >
        <Grid
          item
          md={6}
          sx={{
            display: { xs: "none", md: "flex" },
            alignItems: "center",
            justifyContent: "center",
            p: 2,
          }}
        >
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Box
              sx={{
                borderRadius: 4,
                overflow: "hidden",
                position: "relative",
                "& img": {
                  width: "100%",
                  height: "auto",
                  objectFit: "cover",
                },
              }}
            >
              <img src={sidebardImage} alt="Conference" loading="lazy" />
            </Box>
          </motion.div>
        </Grid>

        <Grid
          item
          md={6}
          xs={12}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            p: 2,
          }}
        >
          <Box sx={{ maxWidth: 480, width: "100%" }}>
            <Box sx={{ textAlign: "center", mb: 4 }}>
              <img
                src={OwwLogo}
                alt="Logo"
                style={{ width: "200px", objectFit: "contain" }}
              />
              <motion.div
                key={isSignup ? "signup" : "login"}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.3 }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    mt: 2,
                    fontWeight: 700,
                    letterSpacing: 1,
                    color: theme.palette.common.white,
                    textShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  }}
                >
                  {isSignup ? t("SelectYourRole") : t("WelcomeBack")}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: "rgba(255,255,255,0.9)",
                    mt: 1,
                    fontSize: "1.1rem",
                  }}
                >
                  {isSignup
                    ? t("ChooseParticipationType")
                    : t("EnterCredentials")}
                </Typography>
              </motion.div>
            </Box>

            <AnimatePresence mode="wait">
              {isSignup ? (
                <motion.div
                  key="signup"
                  initial={{ opacity: 0, x: 100 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -100 }}
                  transition={{ duration: 0.3 }}
                >
                  <Box sx={{ textAlign: "center", mt: 4 }}>
                    <Stack spacing={2}>
                      {[
                        {
                          role: "Visitor",
                          link: "https://eventegration.com/oww-visitor-app-2025",
                        },
                        {
                          role: "Delegate",
                          link: "https://eventegration.com/oww-delegate-online-2025/",
                        },
                        {
                          role: "Student",
                          link: "https://eventegration.com/oww-student-delegate-app-2025",
                        },
                      ].map((role) => (
                        <Button
                          key={role?.role}
                          variant="containedGreen"
                          onClick={() => handleRoleClick(`${role.link}`)}
                          sx={{
                            py: 2,
                            borderRadius: 2,
                            transition: "all 0.3s ease",
                            "&:hover": {
                              transform: "translateY(-2px)",
                              boxShadow: 3,
                            },
                          }}
                        >
                          {t(role.role)}
                        </Button>
                      ))}
                    </Stack>
                    <Button
                      variant="text"
                      onClick={() => setIsSignup(false)}
                      sx={{ mt: 3, color: "rgba(255,255,255,0.7)" }}
                    >
                      {t("BackToLogin")}
                    </Button>
                  </Box>
                </motion.div>
              ) : (
                <motion.div
                  key="login"
                  initial={{ opacity: 0, x: -100 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: 100 }}
                  transition={{ duration: 0.3 }}
                >
                  <GlassPaper sx={{ p: 3, borderRadius: 4 }}>
                    <Typography
                      variant="h4"
                      sx={{
                        color: theme.palette.common.white,
                        mb: 3,
                        fontWeight: 600,
                        textAlign: "center",
                      }}
                    >
                      {t("LoginPanel")}
                    </Typography>

                    <LoginForm
                      onSubmit={onLogin}
                      eventIdParam={eventId}
                      loading={loading}
                      error={error}
                    />

                    <Button
                      fullWidth
                      variant="text"
                      onClick={() => setIsSignup(true)}
                      sx={{ mt: 2, color: "rgba(255,255,255,0.7)" }}
                    >
                      {t("CreateAccount")}
                    </Button>

                    <AnimatePresence>
                      {error && (
                        <motion.div
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0 }}
                        >
                          <Box
                            sx={{
                              p: 2,
                              mt: 2,
                              background: theme.palette.error.dark,
                              borderRadius: 2,
                              display: "flex",
                              alignItems: "center",
                              gap: 1.5,
                            }}
                          >
                            <LockRounded fontSize="small" />
                            <Typography
                              variant="body2"
                              color="error.contrastText"
                            >
                              {error.message}
                            </Typography>
                          </Box>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </GlassPaper>
                </motion.div>
              )}
            </AnimatePresence>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
}

// LoginForm component remains the same as previous version
// Include all its code here without changes
function LoginForm({ onSubmit, eventIdParam, loading, error }) {
  const theme = useTheme();
  const { t } = useTranslation();
  const { handleSubmit, control, formState } = useForm({
    mode: "onChange",
    defaultValues: {
      eventId: eventIdParam || "",
      email: "",
      password: "",
      rememberMe: false,
    },
  });

  const [open, setOpen] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotStatus, setForgotStatus] = useState({
    loading: false,
    error: "",
    success: "",
  });

  const [forgotPassword] = useMutation(FORGOT_PASSWORD_MUTATION);

  const handleForgotPassword = async () => {
    setForgotStatus({ ...forgotStatus, loading: true, error: "" });
    try {
      const { data } = await forgotPassword({
        variables: { eventId: eventIdParam, email: forgotEmail },
      });

      if (data?.forgotPassword2?.success) {
        setForgotStatus({
          loading: false,
          success: t("PasswordResetSent"),
          error: "",
        });
        setTimeout(() => setOpen(false), 2000);
      } else {
        setForgotStatus({
          loading: false,
          error: data?.forgotPassword2?.message || t("PasswordResetFailed"),
          success: "",
        });
      }
    } catch (err) {
      setForgotStatus({
        loading: false,
        error: err.message || t("GeneralError"),
        success: "",
      });
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={3}>
          <Controller
            name="email"
            control={control}
            rules={{ required: t("EmailRequired") }}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                fullWidth
                label={t("Email")}
                variant="filled"
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailRounded sx={{ color: "rgba(255,255,255,0.7)" }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiFilledInput-root": {
                    background: "rgba(255,255,255,0.08)",
                    borderRadius: 2,
                    color: "white",
                    "&:hover": { background: "rgba(255,255,255,0.12)" },
                    "&.Mui-focused": { background: "rgba(255,255,255,0.12)" },
                  },
                  "& .MuiInputLabel-root": {
                    color: "rgba(255,255,255,0.7)",
                  },
                }}
              />
            )}
          />

          <Controller
            name="password"
            control={control}
            rules={{ required: t("PasswordRequired") }}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                fullWidth
                label={t("Password")}
                type="password"
                variant="filled"
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockRounded sx={{ color: "rgba(255,255,255,0.7)" }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiFilledInput-root": {
                    background: "rgba(255,255,255,0.08)",
                    borderRadius: 2,
                    color: "white",
                    "&:hover": { background: "rgba(255,255,255,0.12)" },
                    "&.Mui-focused": { background: "rgba(255,255,255,0.12)" },
                  },
                }}
              />
            )}
          />

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 1,
            }}
          >
            <Controller
              control={control}
              name="rememberMe"
              render={({ field }) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      {...field}
                      sx={{
                        color: "white", // Ensure default color is white
                        "&.Mui-checked": {
                          color: "white", // Checked color
                        },
                      }}
                    />
                  }
                  label={t("RememberMe")}
                  sx={{
                    fontSize: "0.9rem",
                    color: "white", // Override label color
                    "& .MuiTypography-root": { color: "white" }, // Ensures text inside label is white
                  }}
                />
              )}
            />

            <Link
              component="button"
              variant="body2"
              onClick={(e) => (e.preventDefault(), setOpen(true))}
              sx={{
                color: "rgba(251, 248, 248, 0.7)",
                "&:hover": { color: theme.palette.secondary.main },
              }}
            >
              {t("ForgotPassword?")}
            </Link>
          </Box>

          <LoadingButton
            fullWidth
            size="large"
            loading={loading}
            variant="contained"
            type="submit"
            sx={{
              mt: 2,
              py: 1.5,
              borderRadius: 2,
              fontWeight: 600,
              textTransform: "none",
              background: `linear-gradient(45deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 100%)`,
              "&.MuiLoadingButton-loading": {
                background: theme.palette.secondary.dark,
              },
            }}
          >
            {t("SignIn")}
          </LoadingButton>
        </Stack>
      </form>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        TransitionComponent={Zoom}
        PaperProps={{
          sx: {
            background: `linear-gradient(145deg, ${theme.palette.background.paper} 0%, ${theme.palette.background.default} 100%)`,
            borderRadius: 3,
            boxShadow: theme.shadows[10],
          },
        }}
      >
        <DialogTitle
          sx={{
            color: theme.palette.common.black,
            borderBottom: `1px solid ${theme.palette.divider}`,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {t("ResetPassword")}
          <IconButton
            onClick={() => setOpen(false)}
            sx={{ color: "rgba(0, 0, 0, 0.7)" }}
          >
            <CloseRounded />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ py: 3, px: 3 }}>
          <TextField
            fullWidth
            variant="filled"
            type="email"
            label={t("Email")}
            value={forgotEmail}
            onChange={(e) => setForgotEmail(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EmailRounded sx={{ color: "rgba(0, 0, 0, 0.7)" }} />
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiFilledInput-root": {
                background: "rgba(255,255,255,0.08)",
                borderRadius: 2,
                color: "black",
              },
              "& .MuiInputLabel-root": {
                color: "rgba(0, 0, 0, 0.7)",
              },
            }}
          />

          <AnimatePresence>
            {forgotStatus.error && (
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
              >
                <Typography color="error" sx={{ mt: 2 }}>
                  {forgotStatus.error}
                </Typography>
              </motion.div>
            )}

            {forgotStatus.success && (
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
              >
                <Typography color="success.main" sx={{ mt: 2 }}>
                  {forgotStatus.success}
                </Typography>
              </motion.div>
            )}
          </AnimatePresence>
        </DialogContent>

        <DialogActions
          sx={{ p: 2, borderTop: `1px solid ${theme.palette.divider}` }}
        >
          <Button
            onClick={() => setOpen(false)}
            sx={{ color: "rgba(0, 0, 0, 0.7)" }}
          >
            {t("Cancel")}
          </Button>
          <LoadingButton
            loading={forgotStatus.loading}
            onClick={handleForgotPassword}
            variant="contained"
            sx={{
              background: `linear-gradient(45deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 100%)`,
              color: theme.palette.common.white,
            }}
          >
            {t("SendLink")}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

LoginForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  eventIdParam: PropTypes.string,
  loading: PropTypes.bool,
  error: PropTypes.object,
};

const FORGOT_PASSWORD_MUTATION = gql`
  mutation ForgotPassword2($eventId: String!, $email: String!) {
    forgotPassword2(eventId: $eventId, email: $email) {
      success
      message
    }
  }
`;
